import {Flex} from 'antd';
import {ReactElement, ReactNode} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {LangKeyType} from '../../../../../../../../provider/locale/translation/type';

type PropsType = {
    children: ReactNode;
    titleStringKey: LangKeyType;
};

export function HistoryCatalogEditSection(props: PropsType): ReactElement {
    const {children, titleStringKey} = props;

    return (
        <Flex vertical>
            <Text bolder stringKey={titleStringKey} />
            {children}
        </Flex>
    );
}
